<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <div :class="{'document-page':true, mobile: $api.isMobile(), desktop: !$api.isMobile()}" v-if="currentUser">
    <router-view></router-view>
  </div>

</template>

<script>

// Import time logger

export default {

  // Register components
  components: {},

  // Data
  data() {
    return {
    }
  },

  // App mounted
  mounted() {

    // Set task list mode
    this.$dispatch('tree/setTaskListMode', 'task-list')

    // Check for current user
    if (!this.currentUser) {
      this.$router.replace({name: 'login'});
      return;
    }

    // Load notifications
    this.$dispatch('notifications/loadList');

  },

  methods: {
  },

  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
  }
}

</script>

<style lang="scss">

.document-page {
  height: 100%;
}

</style>
